import request from './index'

export function getList(params) {
  return request({
    url: '/salary-records',
    method: 'get',
    params
  })
}

export function getMy(params) {
  return request({
    url: '/salary-records/my',
    method: 'get',
    params
  })
}

// 我的工资条待处理数量（已发送未确认，含待查看/待确认）
export function getMyPendingCount() {
  return request({
    url: '/salary-records/my/pending-count',
    method: 'get'
  })
}

export function getDetail(id) {
  return request({
    url: '/salary-records/' + id,
    method: 'get'
  })
}

export function getMySlipPreview(period) {
  return request({
    url: '/salary-records/my/' + period + '/preview',
    method: 'get'
  })
}

export function confirmMySlip(period) {
  return request({
    url: '/salary-records/my/' + period + '/confirm',
    method: 'post'
  })
}

export function exportExcel(params) {
  return request({
    url: '/salary-records/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function exportBankExcel(params) {
  return request({
    url: '/salary-records/bank-export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function exportSendListExcel(params) {
  return request({
    url: '/salary-records/send-list-export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 制作工资表：按累计预扣预缴法计算当月个税（依据当年历史月份工资）
export function calculateTax(data) {
  return request({
    url: '/salary-records/calculate-tax',
    method: 'post',
    data
  })
}